import gql from 'graphql-tag'

const USER_TABLE_QUERY = gql`
  query users_UserListQuery($search: String, $limit: Int!) {
    users(first: $limit, search: $search) {
      edges {
        node {
          id
          firstName
          lastName
          email
          admin
        }
      }
    }
  }
`
export default USER_TABLE_QUERY



// WEBPACK FOOTER //
// ./src/routes/admin/users.query.js